import options from './claim-devices.component';

export default {
    selector: 'dtClaimDevices',
    options
};
